export default {
  '***': {
    '***': {
      displayFilters: null,
      staticFilters: [
        {
          label: 'Age',
          code: 'age',
          multi: true,
          options: [
            {
              label: '18-24',
              value: 1,
              selected: false
            },
            {
              label: '25-34',
              value: 2,
              selected: false
            },
            {
              label: '35-44',
              value: 3,
              selected: false
            },
            {
              label: '45-54',
              value: 4,
              selected: false
            },
            {
              label: '55+',
              value: 5,
              selected: false
            }
          ]
        },
        {
          label: 'Gender',
          code: 'gender',
          multi: true,
          options: [
            {
              label: 'Male',
              value: 1,
              selected: false
            },
            {
              label: 'Female',
              value: 2,
              selected: false
            },
            {
              label: 'Other',
              value: 3,
              selected: false
            }
          ]
        },
        {
          label: 'Children < 18 in HH',
          code: 'children',
          multi: true,
          options: [
            {
              label: 'Has Children in HH',
              value: 1,
              selected: false
            },
            {
              label: 'No Children in HH',
              value: 2,
              selected: false
            }
          ]
        },
        {
          label: 'Ethnicity',
          code: 'ethnicity',
          multi: true,
          options: [
            {
              label: 'White',
              value: 1,
              selected: false
            },
            {
              label: 'Black',
              value: 2,
              selected: false
            },
            {
              label: 'Latino',
              value: 3,
              selected: false
            },
            {
              label: 'Asian',
              value: 4,
              selected: false
            },
            {
              label: 'American Indian',
              value: 5,
              selected: false
            },
            {
              label: 'Middle Eastern/North African',
              value: 6,
              selected: false
            },
            {
              label: 'Hawaiian/Pacific Islander',
              value: 7,
              selected: false
            },
            {
              label: 'Other',
              value: 8,
              selected: false
            }
          ]
        },
        {
          label: 'Loyalty Amazon Prime',
          code: 'loyal_amazon',
          multi: true,
          options: [
            {
              label: 'Amazon Prime Members',
              value: 1,
              selected: false
            },
            
          ]
        },
        {
          label: 'Loyalty Target',
          code: 'loyal_target',
          multi: true,
          options: [
            {
              label: 'Target Circle Members',
              value: 1,
              selected: false
            },
            
          ]
        },
        {
          label: 'Loyalty Walmart+',
          code: 'loyal_walmart',
          multi: true,
          options: [
            {
              label: 'Walmart+ Members',
              value: 1,
              selected: false
            },
            
          ]
        },
        {
          label: 'PCG',
          code: 'pcg',
          multi: true,
          options: [
            {
              label: 'Busy Parents',
              value: 1,
              selected: false
            },
            {
              label: 'Kid Free Mid-Lifers',
              value: 2,
              selected: false
            },
            {
              label: 'Established Couples',
              value: 3,
              selected: false
            },
            
          ]
        },
        {
          label: 'Guest Engagement',
          code: 'guest_engagement',
          multi: true,
          options: [
            {
              label: 'Supers',
              value: 1,
              selected: false
            },
            {
              label: 'Moderately Engaged',
              value: 2,
              selected: false
            },
            {
              label: 'Less Engaged',
              value: 3,
              selected: false
            },
            {
              label: 'Unengaged',
              value: 4,
              selected: false
            }
            
          ]
        },
      ]
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/configuration/TargetRetail/config/components/scorecard/ScorecardView/ScorecardFilter/index.js